// extracted by mini-css-extract-plugin
export var collapsedSummary = "_px-0";